type ClientHintsNavigator = Navigator & {
    userAgentData?: {
        mobile?: boolean
    }
}

const MOBILE_USER_AGENT = new RegExp(
    [
        'iPhone',
        'iPod',
        'iPad',
        'Android',
        'Windows Phone',
        'IEMobile',
        'BlackBerry',
        'Opera Mini',
        'webOS',
        'Tablet',
        'PlayBook',
        'Silk',
        'Kindle',
    ].join('|'),
    'i',
)

export const BUILDER_NARROW_MAX_WIDTH = 960

export const isMobileUserAgent = (userAgent: string): boolean =>
    MOBILE_USER_AGENT.test(userAgent)

export const isNarrowViewport = (width: number): boolean =>
    width <= BUILDER_NARROW_MAX_WIDTH

export const isMobileDevice = (nav?: ClientHintsNavigator): boolean => {
    if (typeof navigator === 'undefined' && !nav) {
        return false
    }

    const current = nav ?? (navigator as ClientHintsNavigator)

    if (current.userAgentData?.mobile) {
        return true
    }

    const userAgent = current.userAgent || ''

    if (isMobileUserAgent(userAgent)) {
        return true
    }

    const isIpadOs =
        /Macintosh/i.test(userAgent) && (current.maxTouchPoints ?? 0) > 1

    return isIpadOs
}

export const shouldShowBuilderNotice = (width: number): boolean =>
    isNarrowViewport(width)
